export default __webpack_public_path__ + "static/media/Noggin-Rings-1.2f873a78.jpg";